<template>
  <div v-if="isLoading" class="isLoadingDiv">
    <ProgressSpinner />
  </div>

  <div v-else-if="division" class="p-grid p-text-left mt-5">
    <UpgradeBanner v-if="currentUser && !currentUser.upgraded" />
    <div class="p-col-12 p-my-3">
      <h1 class="title is-1 displayInline">
        <img
          v-if="division.se_id"
          class="se_indicator"
          v-tooltip="`SportsEngine ID: ${division.se_id}`"
          src="/se_logo_small.png"
        />
        <div class="colorBall" v-bind:style="{ background: division.color || '#FFFFFF' }" />
        {{ $t("Division.division-name", [division.name]) }}
        <span v-if="division.shortcode"> ({{ division.shortcode }})</span>
      </h1>

      <Button
        class="p-button-outlined p-button-lg"
        style="float: right"
        :label="$t('Button.edit')"
        @click="goRouter(`/divisions/${division.id}/edit`)"
      />
    </div>
    <div class="p-col-12" v-if="division.is_across">
      <span style="color: green"> {{ $t("Division.across-division") }} </span>
    </div>
    <div class="p-col-6 paddedCol">
      <div class="rounded whiteBg paddedCol">
        <div class="title is-5">
          {{ $t("Team.teams") }}
          <Button
            :label="$t('Button.create')"
            class="floatRight normalWeight"
            @click="goRouter(`/teams/new?division_id=${division.id}`)"
          />
        </div>
        <div class="title is-3">
          {{ division.teams.length }}
        </div>
        <router-link v-for="team in division.teams" :to="`/teams/${team.id}`" :key="team.id">
          <p>
            {{ team.name }}
            <span v-if="team.shortcode && team.shortcode.length">({{ team.shortcode }})</span>
            <span v-if="division.is_across && team.division_name"> ({{ team.division_name }}) </span>
          </p>
        </router-link>
      </div>
    </div>
    <div class="p-col-6 paddedCol">
      <div class="rounded whiteBg paddedCol">
        <div class="title is-5">
          {{ $t("Schedule.schedules") }}
          <Button :label="$t('Button.create')" class="floatRight normalWeight" @click="trySchedule(division)" />
        </div>
        <div class="title is-3">
          {{ division.schedules.length }}
        </div>
        <div v-for="schedule in division.schedules" :key="schedule.id">
          <router-link :to="`/schedules/${schedule.id}`">
            {{ schedule.name || "Schedule " + schedule.id }}
          </router-link>
        </div>
      </div>

      <div class="rounded whiteBg paddedCol mt-5">
        <div class="title is-5">
          {{ $t("Tournaments.tournaments") }}
          <Button :label="$t('Button.create')" class="floatRight normalWeight" @click="tryTournament(division)" />
        </div>
        <div class="title is-3">
          {{ division.tournaments.length }}
        </div>
        <div v-for="tournament in division.tournaments" :key="tournament.id">
          <router-link :to="`/schedules/${tournament.id}`">
            {{ tournament.name || "Tournament " + tournament.id }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  components: {},
  data() {
    return {
      division: {},
      isLoading: true,
    };
  },
  methods: {
    trySchedule(division) {
      if (!division.is_across && division.teams.length < 2) {
        this.makeToast("info", this.$t("Toast.mininum_team"));
        return;
      }
      this.goRouter(`/calendar?sd=${division.id}`);
    },
    tryTournament(division) {
      if (!division.is_across && division.teams.length < 4) {
        this.makeToast("info", this.$t("Toast.mininum_team_for_division"));
        return;
      }
      this.goRouter(`/calendar?td=${division.id}`);
    },
    fetchData() {
      api.getDivision(this.$route.params.division_id, this.$store.getters.currentSeason.id).then(response => {
        this.division = response.data;
        this.division.teams.sort(this.dynamicSort("name"));
        this.isLoading = false;
      });
    },
  },
  created() {
    this.fetchData();
  },
  watch: {
    "$route.params.division_id": function() {
      this.isLoading = true;
      this.fetchData();
      window.analytics.page();
    },
  },
  mounted() {
    window.analytics.page();
  },
};
</script>

<style scoped lang="scss"></style>
